import useIntl from "../../hooks/use-intl"
import useLiveConcertState from "../../hooks/use-live-concert-state"
import useTranslate from "../../hooks/use-translate"
import { s } from "../../utilities/common"
import { theme, TI } from "../../utilities/theme"
import { DGText } from "../common/DGText"

import { LiveConcertExtract } from "./Slider"

type LivelabelProps = {
  liveConcert: Pick<
    LiveConcertExtract,
    "endTime" | "startTime" | "streamStartTime" | "reruns"
  >
}
export const Livelabel = ({ liveConcert }: LivelabelProps) => {
  const { status } = useLiveConcertState(liveConcert)
  const t = useTranslate()
  const { dateFormat } = useIntl()

  return status === "live" || status === "pre-live" ? (
    <DGText
      tx={TI.Subheadline08tv}
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
        color: theme.palette.tertiary.accentYellow,
        mt: s("4px"),
      }}
    >
      {t("live_concert__live_now")}
    </DGText>
  ) : (
    <DGText
      tx={TI.Subheadline08tv}
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
        color: theme.palette.white[55],
        mt: s("4px"),
      }}
    >
      {t("component__premiere_label", [
        dateFormat(new Date(liveConcert.startTime), "shortTime"),
      ])}
    </DGText>
  )
}
